export const PAGE = {
  COTTO: '100207768987988',
  TRUEIDTEST: '109674367070653',
  TRUEID: '1858940081055826',
  YASALE: '100701258941039',
  THAILANDPOSTMARTTEST: '115414076948160',
  POWERBUY_MAIN_PAGE: '105046831863695',
  POWERBUY_SHOP_SERVICES: [
    'L1656221467',
    'L1656909148',
    '301460564518350',
    '106229284674746',
    '105344925152387'
  ],
  AIRA_AIFUL: ['1637674519806774', '105017609020919'],
  GPF_BUDDY: ['103823529112921'],
  JUZMATCH_SALE: ['113282044961669', '100550751524009'],
  JUZMATCH_CRM: ['104662695835182', '126479423686694'],
  JUZMATCH_CRM_TEST: ['104662695835182'],
  TREMENDOUS: ['111766474864711', '354477511648995'],
  ROOTS: ['104808655743823', '353174701482518'],
  TTB_MAIN_PAGE: ['116388304732570', '421936097949882', '134792133058142'],
  TTB_CHILD_PAGE: ['122094944984018162', '801290110054036', '148195148379554']
}



// WEBPACK FOOTER //
// ./src/constants/page.js